import {ObjectDTO} from './object-dto';
import {StockMouvementDTO} from "./stock-mouvement-dto";
import {ImageBase64DTO} from "./images/ImageBase64DTO";

export class StockDTO extends ObjectDTO {

  parent: number;
  article: string;
  prixUnitaire: number;
  quantite: number;
  dateEntree: Date;
  dlc: Date;
  dluo: Date;
  actif: boolean;
  dateCreation: Date;
  dateDerniereModification: Date;
  creePar: string;
  modifiePar: string;
  modificationManuelle: boolean;
  moves: StockMouvementDTO[] = [];

  // debut transient
  quantiteReaj: number;
  prixUnitaireUS: number;
  prixUnitaireKilo: number;
  quantiteEnKilo: number;
  quantiteSortieUS: number;
  // fin transient


  // produit article
  produitArticleLibelle: string;
  produitArticleReference: string;
  fournisseurLibelle: string;
  secteurFournisseurLibelle: string;

  // unite de prod zone de stockage
  zdsLibelle: string;
  idZoneDeStockage : number;
  idUdpZoneDeStockage: number;

  // unite de production
  idUdp: number;
  idUdpZds: number;
  udpLibelle: string;

  // lot article
  lotArticle: string;
  lotArticleId: number;
  lotArticleFournisseur: string;
  images: ImageBase64DTO[] = [];

  // catalogue achat
  idCatalogueAchat: number;
  catalogueAchatRefFournisseur: string;

  // unite de mesure
  udmStockLibelle: string;
  udmFacturationLibelle: string;
  uniteFacturationAbreviation: string;
  uniteStockageAbreviation: string;

  // produit declinaison
  produitDeclinaisonCode: string;

  constructor() {
    super();
  }
}
